import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChipComponent, IconComponent, IsDefinedNotEmptyPipe } from '@softline/ui-core';
import { BeweLf } from '../../types/bewe-lf';
import { FieldOkModalService } from '@softline/dynamic';
import { isNullOrEmpty, Store } from '@softline/core';
import { SOFTLINE_FEATURE_DELIVERY_NOTE } from '../../delivery-note.shared';
import { DeliveryNotesStore } from '../../stores/';

@Component({
  selector: 'soft-serial-number-view',
  imports: [CommonModule, ChipComponent, IsDefinedNotEmptyPipe, IconComponent],
  templateUrl: './serial-number-view.component.html',
  styleUrl: './serial-number-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'contents',
  },
})
export class SerialNumberViewComponent {
  readonly editable = input(false, { transform: booleanAttribute });
  readonly productId = input<number>();
  readonly deliveryNoteId = input<number | string>();
  readonly beweLfId = input<number | string>();

  readonly serialNumber = input<BeweLf['seriennr']>();
  readonly serialNumberChange = output<BeweLf['seriennr']>();

  readonly fokService = inject(FieldOkModalService);

  readonly store = inject(Store);

  async openEditModal(): Promise<void> {
    const productId = this.productId();
    const deliveryNoteId = this.deliveryNoteId();
    const beweLfId = this.beweLfId();

    if (isNullOrEmpty(productId) || isNullOrEmpty(beweLfId) || !deliveryNoteId) return;

    const result = await this.fokService.open('seriennr', {
      idartstamm: productId,
    });

    if (!result || result === 'DISMISSED') return;

    this.serialNumberChange.emit({
      editable: this.serialNumber()?.editable ?? false,
      mandatory: this.serialNumber()?.mandatory ?? false,
      seriennummer: result['seriennummer'],
    });
  }
}
